
/**
 * polyfill function for view transitions. Does not show transition, if the browser does not support it
 * @param {() => void} callback
 */
export function viewTransition(callback) {
 const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    if (isFirefox) {
        callback();
        return {
            finished: Promise.resolve() 
        };
    } else {
        if (!document.startViewTransition) {
            callback();
            return {
                finished: Promise.resolve()
            };
        }
        return document.startViewTransition(() => {
            callback();
        });
    }
}


/**
 * read cookie
 * @param {string} name
 * @returns {?string}
 */
export function getCookie(name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

/**
 * create cookie
 * @param {string} name
 * @param {string} value
 * @param {string} days
 */
export function setCookie(name, value, days) {
    let expires = '';
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }

    const hostParts = location.host.split('.');
    const domain = location.hostname === 'localhost'
        ? 'localhost'
        : [hostParts[hostParts.length - 2], hostParts[hostParts.length - 1]].join('.');

    document.cookie = `${name}=${value || ''}${expires}; secure; path=/; domain=${domain}`;
}

/**
 * remove cookie
 * @param {string} name
 */
export function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**
 * create hash value
 * @param {number} length
 * @returns {string}
 */
export function createRandomString(length) {
    let result = '';
    const characters = '#ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}

export function gtag() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push(arguments);
}